import { WarningCard } from '@eika/card';
import { Link } from '@eika/link';
import { RichIconTypes } from '@eika/rich-icon';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';

export const ProcessNotFoundError = () => {
    const { backToOverview, apiError } = useTranslation();
    const { overview } = useLinks();

    return (
        <WarningCard
            icon={RichIconTypes.DATAFEIL_3}
            title={apiError.processNotFoundHeader}
            data-testid="process-with-id-not-found"
        >
            <p role="alert">{apiError.processNotFoundIngress}</p>
            <Link linkType="button-positive" href={overview.url}>
                {backToOverview}
            </Link>
        </WarningCard>
    );
};
